<template>
  <div class="mb-3">
 <h4 class="col-12 page-title text-primary">{{channelDescription}}</h4>

 <p   v-if="entity.length==0" class="
    text-muted text-center" >
       - <i class="feather icon-search  m-2"></i>
      Nessuna risorsa trovata -
    </p>
    <div class="row" v-if="entity && entity.length>0 && channel=='terservice'">



      <div class="col-12">
        <table class="table w-100 mb-5" id="tblTersService"  v-if="entity && entity.length>0 && channel=='terservice'">
        <thead>
            <tr>
<th>Testata</th>
<th>Data Inizio</th>
<th>Data Fine</th>
<th>Importo</th>
<th>Data annullamento</th>
<th>Importo annullato</th>


            </tr>
        </thead>
        <tbody>
 <tr  v-for="item in entity" v-bind:key="item.orderId">
<td>{{item.articleName}}</td>
<td>{{item.dateStart | formatDate}}</td>
<td>{{item.dateEnd | formatDate}}</td>
<td>{{item.amount | currency}}</td>
<td>{{item.cancellationDate | formatDate}}</td>
<td>{{item.cancellationAmount | currency}}</td>

            </tr>

             </tbody>
          </table>
      </div>
    </div>
      
       <div class="row" v-if="entity && entity.length>0 && channel=='vnp'">
<h4 class="col-12 page-title">{{channelDescription}}</h4>


      <div class="col-12">
        <table class="table w-100 mb-5"  id="tblvnp" v-if="entity && entity.length>0 && channel=='vnp'">
          <thead>
            <tr>
<th>Data</th>
<th>N. Ordine</th>
<th>Prodotti</th>
<th>Dispositivo</th>
<th>Tipo pagamento</th>
<th>Importo Totale</th>


            </tr>
            </thead>
              <tbody>
<tr  v-for="item in entity" v-bind:key="item.orderId">
<td>{{item.date| formatDate}}</td>
<td>{{item.number}}</td>
<td>{{item.articleName}}</td>
<td>{{item.device}}</td>
<td>{{item.paymentCode}}</td>
<td>{{item.amount | currency}}</td>
            </tr>
              </tbody>
          </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "orderList",

  props: {
    channel: {
      type:String,
      required: true,
      default :() =>"terservice"
    },
    channelDescription: {
      type:String,
      required: true,
      default :() =>"Abbonamenti Cartacei"
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      entity: [],
     
      descriptions:[]
    };
  },
  methods: {
    getDescription(code) {
      for(var i=0; i< this.descriptions.length; i++){
        if(this.descriptions[i].code == code)
        return  this.descriptions[i].value

      }
     return code;
    },
    loadData(){

    let me = this;
    

 axios.get(`order/${me.channel}/${me.value}`).then((response) => {
        me.entity = response.data;
      });

    }
  },

  mounted:function() {
   
     setTimeout(this.loadData, 1000);     
           

 
  },
};
</script>
